import { useTranslation } from 'react-i18next';
import { NavLink } from 'react-router';

import { cn } from '@/utils/cn';

const LINKS = [
  { to: '/content', end: true, labelKey: 'nav.overview' as const },
  { to: '/content/sermons', end: false, labelKey: 'nav.sermons' as const },
  { to: '/content/devotionals', end: false, labelKey: 'nav.devotionals' as const },
  { to: '/content/announcements', end: false, labelKey: 'nav.announcements' as const },
  { to: '/content/videos', end: false, labelKey: 'nav.videos' as const },
  { to: '/content/galleries', end: false, labelKey: 'nav.galleries' as const },
  { to: '/content/comments', end: false, labelKey: 'nav.comments' as const },
  { to: '/content/socials', end: false, labelKey: 'nav.socials' as const },
];

export const ContentSubnav = () => {
  const { t } = useTranslation('content');

  return (
    <nav className="mb-4 flex flex-wrap gap-2" aria-label={t('title')}>
      {LINKS.map((link) => (
        <NavLink
          key={link.to}
          to={link.to}
          end={link.end}
          className={({ isActive }) =>
            cn(
              'rounded-md px-3 py-1.5 text-body-sm',
              isActive
                ? 'bg-brand/10 font-medium text-brand'
                : 'text-fg-secondary hover:bg-surface-muted hover:text-fg',
            )
          }
        >
          {t(link.labelKey)}
        </NavLink>
      ))}
    </nav>
  );
};
